import React from "react";
import PropTypes from "prop-types";

function EmbedVideoSkeleton({ children }) {
  return (
    <div
      data-test="embed-video-skeleton"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "#e0e0e0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1,
        borderRadius: "6px",
        border: "none",
      }}
    >
      {children}
    </div>
  );
}

EmbedVideoSkeleton.propTypes = {
  children: PropTypes.node,
};

EmbedVideoSkeleton.defaultProps = {
  children: null,
};

export default EmbedVideoSkeleton;
